import { colors } from 'design-system';
import IconProps from './IconProps';
import VectorIcon from './VectorIcon';

const CalendarIcon = ({
  width = 24,
  height = 24,
  color = colors.bright_turquoise,
}: IconProps): JSX.Element => (
  <VectorIcon width={width} height={height}>
    <path
      d="M19 3.87866H5C3.89543 3.87866 3 4.67575 3 5.659V18.1214C3 19.1046 3.89543 
      19.9017 5 19.9017H19C20.1046 19.9017 21 19.1046 21 18.1214V5.659C21 
      4.67575 20.1046 3.87866 19 3.87866Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 2.09814V5.65883"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 2.09814V5.65883"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 9.21948H21"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </VectorIcon>
);

export default CalendarIcon;
